import {getFormattedNumberWithSuffix} from '../../../common/shared/utils/getFormattedNumberWithSuffix';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {SearchThemeKeywordToolbarProps} from './SearchThemeKeywordToolbarProps.interface';

export function SearchThemeKeywordToolbar({
  className,
  total,
  sortOptionName,
  onClickSortOption,
  ...props
}: SearchThemeKeywordToolbarProps) {
  return (
    <div className={twMerge('flex items-center', className)} {...props}>
      <Text className="font-small2 flex-1 text-theme-solid-60">
        {getFormattedNumberWithSuffix(total)}개
      </Text>
      <div
        className="flex shrink-0 cursor-pointer items-center"
        onClick={onClickSortOption}
      >
        <Text className="font-small2 mr-4pxr text-theme-solid-100">
          {sortOptionName}
        </Text>
        <Icon type={IconType.TabArrowDown} />
      </div>
    </div>
  );
}
